import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Heart, Landmark, Map, Shield, TrendingUp } from 'lucide-react';
export function Issues() {
  const issues = [{
    title: 'Local Decision-Making',
    description: 'Keeping choices about Arizona neighborhoods with the people who live with the results.',
    icon: Building2
  }, {
    title: 'Growth & Land Use',
    description: 'Protecting the tools communities use to shape responsible growth on their own terms.',
    icon: Map
  }, {
    title: 'Quality of Life',
    description: 'Advancing policies that help every Arizona community remain a great place to live and raise a family.',
    icon: Heart
  }, {
    title: 'Safe Neighborhoods',
    description: 'Supporting local leaders with the flexibility and resources to keep neighborhoods safe.',
    icon: Shield
  }, {
    title: 'Strong Local Economies',
    description: 'Fostering responsible economic development, local opportunity, and resilient community economies.',
    icon: TrendingUp
  }, {
    title: 'Lasting Freedom',
    description: 'Defending the distinct roles of federal, state, and local government so power remains accountable.',
    icon: Landmark
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="issues" className="py-24 bg-white scroll-mt-24" data-id="element-147" data-mp="2dixo1ljnwejv">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148" data-mp="2ij22l610ez7g">
        <div className="text-center mb-16" data-id="element-149" data-mp="2ih8z1zlp0v3o">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-pac-navy mb-4" data-id="element-150" data-mp="3684l0g3gww30">
            Where Local Voices Matter Most
          </h2>
          <div className="w-24 h-1 bg-pac-red mx-auto" data-id="element-151" data-mp="3b0xol0n79ydi" />
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-152" data-mp="3kvlclis3youx">
          {issues.map(issue => <motion.article key={issue.title} variants={itemVariants} className="bg-slate-50 p-8 rounded-xl border border-slate-200" data-id="element-153" data-mp="36wdb2j8h34nk">
              <div className="w-14 h-14 bg-white rounded-lg shadow-sm flex items-center justify-center mb-6" data-id="element-154" data-mp="2x58xnnyg3ruu">
                <issue.icon className="h-7 w-7 text-pac-blue" data-id="element-155" data-mp="2s5w9mzvu8eqo" />
              </div>
              <h3 className="font-serif text-2xl font-bold text-pac-navy mb-3" data-id="element-156" data-mp="2o5m75x7986gk">
                {issue.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-157" data-mp="2j4ofmu0cu02e">
                {issue.description}
              </p>
            </motion.article>)}
        </motion.div>
      </div>
    </section>;
}